import * as React from 'react';

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { createStyles, makeStyles, Theme } from '@material-ui/core';

import { useSelector } from 'src/utils';

import { initTerminal } from 'src/actions/eLearning';

/**
 * style
 */
const useStyles = makeStyles((_: Theme) =>
	createStyles({
		root: {
			margin: 'auto',
			width: '100%',
		},
	})
);

/**
 * Componentが受け取る値
 */
interface IStates {
	/**
	 * 現ページの研修ID
	 */
	careerId: string;

	/**
	 * 現ページのクラスID
	 */
	classId: string;

	/**
	 * 現ページが閲覧モードならtrue
	 */
	isPreview: boolean;
}

/**
 * Componentが受けとるイベントハンドラ
 */
interface IEvents {
	/**
	 * 次へボタン更新
	 */
	handleChangePlayerStatus: (playerStatus: boolean) => void;
}

/**
 * ELearningTerminalのProps型
 */
export type IELearningTerminalProps = IStates & IEvents;

/**
 * 最終ページ処理
 */
export const ELearningTerminal: React.FC<IELearningTerminalProps> = ({
	careerId,
	classId,
	isPreview,

	handleChangePlayerStatus,
}) => {
	const classes = useStyles();
	const dispatch = useDispatch();

	/** ログイン中ユーザのID */
	const userId = useSelector(state => state.session.userAttr.userId);

	useEffect(
		// マウント時初期化
		() => {
			handleChangePlayerStatus(true);
			dispatch(
				initTerminal({
					careerID: careerId,
					classID: classId,
					isPreview,
					userId,
				})
			);
		},
		[dispatch, initTerminal, careerId, classId, isPreview, userId]
	);

	return <div className={classes.root} />;
};
ELearningTerminal.displayName = 'ELearningTerminal';



// WEBPACK FOOTER //
// ./src/containers/ELearningTerminal.tsx